import React, { useState, useEffect } from "react";

const Profile = () => {
  const [currentUser, setCurrentUser] = useState("");

  useEffect(() => {
    var retrievedObject = localStorage.getItem("currentUser");
    setCurrentUser(JSON.parse(retrievedObject));
  }, []);

  const style = {
    profileWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #0D6EFD",
      borderRadius: "10px",
      padding: "20px",
      margin: "20px",
      width: "60%",
      height: "auto",
      backgroundColor: "#F1F3F8",
    },
    toolbar: {
      width: "100%",
      textAlign: "center",
      marginBottom: "20px",
    },
    detailsContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
    detail: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "70%",
      marginBottom: "10px",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={style.profileWrapper}>
        <div style={style.toolbar}>
          <h2>User Profile</h2>
        </div>
        {currentUser && (
          <div style={style.detailsContainer}>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>First Name</span>
              <p>{currentUser.given_name}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Last Name</span>
              <p>{currentUser.family_name}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Email Address</span>
              <p>{currentUser.email}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Phone Number</span>
              <p>{currentUser.telephoneNumber}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Preferred Username</span>
              <p>{currentUser.preferred_username}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Verified</span>
              <p>{currentUser.email_verified ? "True" : "False"}</p>
            </div>
            <div style={style.detail}>
              <span style={{ fontWeight: "bold" }}>Roles</span>
              <ul style={{ listStyleType: "disc" }}>
                {currentUser.realm_access.roles.map((role, index) => (
                  <li key={index}>{role}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Profile;
